module.exports = __webpack_public_path__ + "static/Thumb_DissolvingApple_FX-810001a87528d15d2d6bcbfb75d9ee1d.png";